import { BootConfig } from '../App';

export class URLOptionsParser {
  public static parse(defaultConfig: BootConfig) {
    const options = this.parseURLParams();
    console.log('Passed options: ', options);
    return { ...defaultConfig, ...options };
  }

  // Can use URLSearchParams in future and polyfill.
  private static parseURLParams() {
    const search = window.location.search;
    const keyValuePairs = search.slice(search.indexOf('?') + 1).split('&');

    const params: { [key: string]: string } = {};
    keyValuePairs.map((keyValuePair) => {
      const [key, value] = keyValuePair.split('=');
      params[key] = window.decodeURIComponent(value);
    });

    return params;
  }
}
